import { render, staticRenderFns } from "./UsersListPage.vue?vue&type=template&id=78fd4a09&scoped=true&"
import script from "./UsersListPage.vue?vue&type=script&lang=ts&"
export * from "./UsersListPage.vue?vue&type=script&lang=ts&"
import style0 from "./UsersListPage.vue?vue&type=style&index=0&id=78fd4a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd4a09",
  null
  
)

export default component.exports